import { EVENT_VIEW_SIMILAR_PRODUCTS } from '~~/constants/googleTagManager';
import type { ViewSimilarProducts, EcommerceViewSimilarProducts } from '~~/types/integrations/tagManager/TagViewSimilarProducts';

export const buildViewSimilarProductsTags = ({
  sourceSku,
  viewSimilarProductItems,
}: {
  sourceSku: string;
  viewSimilarProductItems: ViewSimilarProducts;
}) => ({
  event: EVENT_VIEW_SIMILAR_PRODUCTS,
  ecommerce: {
    detail: {
      source_id: sourceSku,
      items: viewSimilarProductItems,
    },
  } as EcommerceViewSimilarProducts,
});
